import React, { useEffect, useState, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { getDirection, hardCopy, numToPrice, toast } from '../../utils/functions';
import SearchablePicker from '../master/SearchablePicker';

export default function Pricing({ placeholder, title, unit, value, pickerData, submit, fixItem,getPrice,recomPrice }) {

    const [valueArray, setValueArray] = useState([]);
    const [defaultElement, setDefaultElement] = useState({
        name: null,
        price: '',
    });
    const { t, i18n } = useTranslation();
    const pickerArray = useMemo(() => pickerData, [pickerData]);
//////
    useEffect(() => {
       if(fixItem){
           setDefaultElement(prevState =>({
               ...prevState,
               price: recomPrice? numToPrice(recomPrice) : '',
           }))
       }
    }, [recomPrice,fixItem]);

    useEffect(() => {
        setValueArray(value);
        /////
        setDefaultElement({
            name: null,
            price: '',
        });
    }, [value]);

    function addElement() {
        if (defaultElement.name) {
            valueArray.push(defaultElement);
            submit(valueArray);
            setDefaultElement({
                name: null,
                price: '',
            });
        } else
            toast(t('Please complete the feilds'), 'error');
    }
    function removeElement(index) {
        valueArray.splice(index, 1);
        submit(valueArray);
    }
    function select(name, index) {
        const found = valueArray.find(r => r.name === name);

        if (!found) {
            valueArray[index].name = name;
            submit(valueArray);
        } else
            toast(t('You already choose this accessories'), 'error');
    }
    function changePrice(price, index) {
        // let data = hardCopy(valueArray);
        // data[index].price = numToPrice(price);
        // setValueArray(data);
        ////
        valueArray[index].price = numToPrice(price);
        submit(valueArray);
    }
    function changeDefaultElement(value, type) {
        // setDefaultElement(prevState => ({
        //     ...prevState,
        //     [type]: type === 'price' ? numToPrice(value) : value,
        // }));
        const found = valueArray.find(r => r.name === value);
        if(found){
            toast(t('You already choose this accessories'), 'error');
            setDefaultElement({
                name: null,
                price: '',
            });
        }else{
            if([t('Wage list'), t('Accessories list')].includes(title) && type === 'name'){
                const chosenValue = pickerArray.find(r=>r.name === value);
                if(chosenValue){
                    getPrice(chosenValue.id)
                    setDefaultElement({
                        name: value,
                        price: recomPrice? numToPrice(recomPrice):''
                    })
                }else {
                    setDefaultElement({
                        name: value,
                        price: recomPrice? numToPrice(recomPrice):''
                    })
                }
            }else{
                setDefaultElement(prevState => ({
                    ...prevState,
                    [type]: type === 'price' ? numToPrice(value) : value,
                }));
            }
        }

    }
    return (
        <div className='pricing'>
            <div className={`d-flex space-between ${getDirection(i18n.language) ==='rightToLeft' ? 'flex-row-reverse': ''} align-items-center`}>
                <p>{ title }</p>
            </div>
            {
                valueArray.map((data, index) => {
                    return (
                        <div className={`d-flex ${getDirection(i18n.language) ==='rightToLeft' ? 'flex-row-reverse': ''} align-items-center mt10`} key={index}>
                            <div className='pl5 picker-parent'>
                                {
                                    (fixItem && [t('Wage list'), t('Accessories list')].includes(title)) ?
                                        <SearchablePicker
                                            value={ data.name }
                                            data={ pickerArray }
                                            placeholder={ placeholder }
                                            titleKey='name'
                                            valueKey='name'
                                            rtl={getDirection(i18n.language) === 'rightToLeft'}
                                            onSelect={ (val) => select(val, index) }
                                        />
                                         :
                                        <SearchablePicker
                                            value={ data.name }
                                            data={ pickerArray }
                                            placeholder={ placeholder }
                                            titleKey='name'
                                            valueKey='name'
                                            rtl={getDirection(i18n.language) === 'rightToLeft'}
                                            onSelect={ (val) => select(val, index) }
                                            taggable
                                        />
                                }
                            </div>
                            <div className='price-parent pr5' style={{overflow: 'hidden'}}>
                                <div className='input-parent withIcon'>
                                    <input
                                        type='text'
                                        placeholder={ unit === 'percent' ? t('Percent') : unit === 'quality' ? t('Quality grade') : t('Price') }
                                        value={data.price}
                                        onChange={(e) => changePrice(e.target.value, index)}
                                        onBlur={() => submit(valueArray)}
                                        maxLength={unit === 'percent' ? 3 : unit === 'quality' ? 1 : 13}
                                    />
                                    <i>
                                        {
                                            unit === 'percent' ?
                                                '%' :
                                                unit === 'quality' ?
                                                    '°' :
                                                    t('rial')
                                        }
                                    </i>
                                </div>
                            </div>
                            <i className='fas fa-minus-circle mr10' onClick={() => removeElement(index)} />
                        </div>
                    );
                })
            }
            <div className={`d-flex ${getDirection(i18n.language) ==='rightToLeft' ? 'flex-row-reverse': ''} align-items-center mt10 pt10`} style={{borderTop: '1px solid #ddd'}}>
                <div className='pl5 picker-parent'>
                    {
                        (fixItem && [t('Wage list'), t('Accessories list')].includes(title)) ?
                            <SearchablePicker
                                value={defaultElement.name}
                                data={pickerArray}
                                placeholder={placeholder}
                                titleKey='name'
                                valueKey='name'
                                rtl={getDirection(i18n.language) === 'rightToLeft'}
                                onSelect={(val) => changeDefaultElement(val, 'name')}
                            />
                            :
                            <SearchablePicker
                                value={defaultElement.name}
                                data={pickerArray}
                                placeholder={placeholder}
                                titleKey='name'
                                valueKey='name'
                                rtl={getDirection(i18n.language) === 'rightToLeft'}
                                onSelect={(val) => changeDefaultElement(val, 'name')}
                                taggable
                            />
                    }
                </div>
                <div className='price-parent pr5 pl5' style={{overflow: 'hidden'}}>
                    <div className='input-parent withIcon'>
                        <input
                            type='text'
                            placeholder={unit === 'percent' ? t('Percent') : unit === 'quality' ? t('Quality grade') : t('Price')}
                            value={defaultElement.price}
                            onChange={(e) => changeDefaultElement(e.target.value, 'price')}
                            maxLength={unit === 'percent' ? 3 : unit === 'quality' ? 1 : 13}
                        />
                        <i>
                            {
                                unit === 'percent' ?
                                    '%' :
                                    unit === 'quality' ?
                                        '°' :
                                        t('rial')
                            }
                        </i>
                    </div>
                </div>
                <i className='fas fa-plus-circle mr10' onClick={addElement} />
            </div>
        </div>
    );

}